import React, { useRef, useState, useMemo } from 'react';
import { useOutsideClick } from '@hooks/useOutsideClick';
import { getComputerName } from '@helpers/stringHelpers';
import './SimpleSelect.scss';

export interface SimpleSelectProps<T> {
  disabled?: boolean;
  selectFunction: (item: T) => void;
  list: T[];
  name: string;
  label?: string;
  required?: boolean;
  title: string;
}

export const SimpleSelect = <T,>({
  disabled = false,
  selectFunction,
  list,
  name,
  label,
  required = false,
  title,
}: SimpleSelectProps<T>) => {
  const [isShowing, setIsShowing] = useState(false);

  const selectRef = useRef(null);
  const handleClickOutside = () => {
    setIsShowing(false);
  };
  useOutsideClick(selectRef, handleClickOutside);

  const handleClick = () => {
    if (!disabled) {
      setIsShowing(!isShowing);
    }
  };

  const onSelect = (item: T) => {
    selectFunction(item);
    setIsShowing(false);
  };

  const listItems = useMemo(() => {
    return list
      ? list.map((item, key) => (
          <li key={key} onClick={() => onSelect(item)}>
            {name ? item[name] : item}
          </li>
        ))
      : [];
  }, [list, name]);

  return (
    <div ref={selectRef} className={disabled ? 'c-simple-select disabled' : 'c-simple-select'}>
      {label && (
        <label htmlFor={getComputerName(label)}>
          {label}
          {required && ' *'}
        </label>
      )}
      <div className='c-button' data-name={getComputerName(label)}>
        <div className='c-simple-select-wrapper' onClick={handleClick}>
          <span>{title}</span>
          <i className='icon-angle-down' />
        </div>
        {isShowing && (
          <div className='c-simple-select-list'>
            <ul>{listItems}</ul>
          </div>
        )}
      </div>
    </div>
  );
};
